import CoreBase from '../../../../services/engines/CoreBase';

class UrlRewriter extends CoreBase {
    _name = 'UrlRewriter';

    /**
     * Rewrites all <a href> links to postMessage — sandbox blocks window.open.
     * @param {string} html
     * @returns {string}
     */
    rewrite(html) {
        return html.replace(
            /<a\s([^>]*href="(https?:\/\/[^"]+)"[^>]*)>/gi,
            this._replaceLink.bind(this)
        );
    }

    /**
     * @param {string} match
     * @param {string} attrs
     * @param {string} url
     * @returns {string}
     */
    _replaceLink(match, attrs, url) {
        const safeUrl = url.replace(/'/g, "\\'");
        return `<a ${attrs} onclick="window.parent.postMessage({type:'jerny:openurl',url:'${safeUrl}'},'*');return false;">`;
    }
}

const urlRewriter = new UrlRewriter();
export default urlRewriter;
